import React from 'react'
import { Link } from 'react-scroll'
import styles from './footer.module.scss'
import { CiLinkedin } from "react-icons/ci"
import { FiGithub } from "react-icons/fi"
import { AiOutlineDribbble , AiOutlineHome , AiOutlineTrophy } from "react-icons/ai"
import { BiImages } from "react-icons/bi"


export default function FooterPtBr() {
  return (
    <footer className={styles.container}>
            <div className={styles.main_text}>
                <span>Feito Por</span>
                <h2>Marcos Maio</h2>
            </div>
            <div className={styles.container_division}>
                  
                        <nav>
                            <ul className={styles.container_list}>
                                <li className={styles.container_item}>
                                    <Link 
                                    to='home' 
                                    smooth={true} 
                                    duration={500}
                                    offset={-100}
                                    spy={true}
                                    >
                                <AiOutlineHome style={{color: '#202020', marginRight: '0.2em'}} />Inicio</Link>
                                </li>
                                <li className={styles.container_item}>
                                    <Link 
                                    to='skils' 
                                    smooth={true} 
                                    duration={500}
                                    offset={-100}
                                    spy={true}
                                    >
                                <AiOutlineTrophy style={{color: '#202020', marginRight: '0.2em'}} />Habilidades</Link>
                                </li>
                                <li className={styles.container_item}>
                                    <Link 
                                    to='projects' 
                                    smooth={true} 
                                    duration={500}
                                    offset={-100}
                                    spy={true}
                                    >
                                <BiImages style={{color: '#202020', marginRight: '0.2em'}} />Projetos</Link>
                                </li>
                            </ul>
                        </nav>
            </div>
            <div className={styles.redes_sociais}>
                    <a href='https://www.linkedin.com/in/marcos-maio-792aab23a/' target="_blank" rel="noreferrer"> 
                        <CiLinkedin style={{color: '#202020'}}/>
                    </a>
                    <a href='https://github.com/MarcosMaio' target="_blank" rel="noreferrer"> 
                        <FiGithub style={{color: '#202020'}}/>
                    </a>
                    <a href='https://dribbble.com/MarcosMaio/about' target="_blank" rel="noreferrer"> 
                        <AiOutlineDribbble style={{color: '#202020'}} />
                    </a>
            </div>
            <span className={styles.copyright}>
            © {new Date().getFullYear()}
                {' '}
                Copyright - Todos Os Direitos Reservados
            </span>
            
    </footer>


  )
}
